import { useEffect, useState } from "react";

export const useIsMobile = (breakpoint:number=768): boolean => {
    const [isMobile,setIsmobile] = useState<boolean>(false);
    useEffect(()=>{
        const checkIsMobile = () => {
            setIsmobile(window.innerWidth < breakpoint);
        }
        checkIsMobile();
        window.addEventListener('resize',checkIsMobile);
        return () => {
            window.removeEventListener('resize',checkIsMobile);
        }
    },[breakpoint])
    return isMobile
}